const brand = sessionStorage.getItem('brand');

export const shared = {
  bpDropDown: {
    placeholders: {
        search: 'Kërko'
    }
},
bpTable: {
    loadMore: 'Ngarko Më Shumë',
    view: 'Shikoje'
},
countryDropDown: {
    placeholders: {
        searchCountry: 'Kërko Shtetin'
    }
},
createNew: {
    continue: 'Vazhdo',
},
datePicker: {
    chooseADate: 'Zgjidh një datë',
},
dateRangePicker: {
    choosePeriod: 'Zgjidh Periudhën',
    today: 'Sot',
    lastWeek: 'Javën e Fundit',
    lastMonth: 'Muajin e Fundit'
},
demoBotModal: {
    pleaseProvideNumberForTesting: 'Ju lutemi sigurohuni të jepni numrin që dëshironi të përdorni për testim',
    resendOtp: 'Ridërgo OTP',
    enterOtp: 'Vendos OTP',
    verifyOtp: 'Verifikoni OTP',
    sendOtp: 'Dërgo OTP',
    cancel: 'Anulo',
    placeholders: {
        phone: 'Telefoni*',
        enterOtp: 'Vendos OTP*',
    }
},
feedback: {
    pleaseSelectYourReason: 'Ju lutemi zgjidhni arsyen tuaj',
    cancel: 'Anulo',
    submit: 'Dërgo!',
    giveFeedback: 'Jepni vlerësim',
    ratings: 'Vlerësimet',
    reasonBehindYourDecision: 'Arsyeja pas vendimit tuaj',
    shareYourExperience: 'Ndani eksperiencën tuaj',
    reason1: 'arsye1',
    reason2: 'arsye2'
},
feedbackModal: {
    paymentIsInProgress: 'Pagesa është në proces',
    pleaseDoNotCloseThisWindow: 'Ju lutemi mos e mbyllni këtë dritare',
    placeholders: {
        name: 'Emri',
        email: 'Email*',
        phone: 'Telefoni*',
        pleaseShareYourUseCase: 'Ju lutemi ndani rastin tuaj të përdorimit'
    }
},
layout: {
    sidebar: {
        notifications: 'Njoftimet',
        myAccount: 'Llogaria ime',
        logout: `Ç'aktivizuar`,
        goOnline: 'Shko Online',
        manage: 'Menaxho',
        deactivate: 'Deaktivizo',
        activate: 'Aktivizo',
        delete: 'Fshi',
        home: 'Kreu',
        bots: 'Bots',
        inbox: 'Posta hyrëse',
        analytics: 'Analitikat',
        team: 'Ekipi',
        subscriptions: 'Abonimet',
        more: 'Më shumë',
        users: 'Përdoruesit',
        partnerTeam: 'Ekipi Partner',
        createNewBot: 'Krijo Bot të Ri',
        dashboard: 'Paneli',
        customers: 'Klientët',
        partnerPanel: 'Paneli Partner',
        raiseATicket: 'Ngrit një Biletë',
        plans: 'Plane',
        activities: 'Aktivitetet',
        feedbacks: 'Vlerësimet',
        emailActivity: 'Aktiviteti Email',
        configurations: 'Konfigurimet',
        copy: 'Kopjo',
        developer: 'Zhvilluesit',
        yourFriendWillMissYou: 'Shoku juaj do ju mungojë',
        rateYourBotCreationExperience: 'Vlerësoni përvojën tuaj në krijimin e botit',
        whatMadeYouDeleteYourBot: 'Çfarë ju bë të fshini botin tuaj?',
        iCreatedByMistake: 'E krijuar gabimisht',
        iWantToCreateAnotherBot: 'Dua të krijoj një bot tjetër',
        couldNotFindFeaturesThatINeeded: 'Nuk mund të gjeja veçoritë që më duheshin',
        uiWasHardToNavigate: 'UI ishte e vështirë për navigim',
        iDonotWantToTell: 'Nuk dua të them',
        other: 'Tjetër',
        weWillDoOurBestToMakeAutomationFun: 'Ne do të bëjmë çmos të bëjmë automatizimin argëtues dhe të thjeshtë për të gjithë.',
        appTooltip: {
            TOOLTIP_GO_ONLINE: 'Ndërro për të lejuar ose bllokuar kërkesat për chat në kohë reale',
            TOOLTIP_NOTIFICATION: 'Të gjitha njoftimet',
            TOOLTIP_MY_ACCOUNT: 'Profili juaj dhe siguria e fjalëkalimit',
            TOOLTIP_LOGOUT: `Ç'aktivizo nga paneli`
        },
        modal: {
            logout: `Ç'aktivizo`,
            botDeleteFeedbackForm: 'Formulari i Vlerësimit për Fshirjen e Botit',
            areYouSureToLogOut: `A jeni të sigurt se dëshironi të ç'aktivizoheni?`,
            yesIWillBeBack: `Po! Do të kthehem`,
            deleteBot: 'Fshi Botin',
            areYouSureToDeleteBot: 'A jeni të sigurt se dëshironi të fshini këtë bot?',
            cancel: 'Anulo',
            saveAndDelete: 'Ruaj dhe Fshi'
        }
    }
},
modal: {
    cancel: 'Anulo',
    yesDelete: 'Po, Fshi!'
},
notify: {
    youHave: 'Keni ',
    new: ' të reja '
},
profileIcon: {
    appTooltip: {
        weSuggestUsingYourCompanyLogo: 'Ne sugjerojmë të përdorni logon e kompanisë suaj. Shtoni një imazh të përlotur PNG ose JPG nën 1 MB.'
    }
},
upgradeModal: {
    upgradeToKingPlan: 'Ups! Plan baby ofron VETËM NJË bot TË LIRË. Ju lutemi ndërtoni në planin King për të krijuar më shumë botë.',
    noIAmGood: 'Jo, jam i mirë',
    iWantToUpgrade: 'Dua të ndërtoj',
    oops: 'Ups! ',
    planOfferOnlyOneFreeBot: ' ofron VETËM NJË bot TË LIRË. Ju lutemi ndërtoni në ',
    planToCreateMoreBots: ' për të krijuar më shumë botë.'
},
webPreview: {
    preview: ' Parashiko',
    botsMessages: `Mesazhet e Botit`,
    bot: 'Bot ',
    eleven36AM: ' 11:36 PD',
    usersReply: `Përgjigja e Përdoruesit`,
    landingPageBot: 'Boti i Faqes Hyrëse',
    chatbot: 'Chatbot',
    chat: 'Chat',
    placeholders: {
        typeYourAnswer: 'Shkruani përgjigjen tuaj'
    }
},
paymentLink: {
    discardPayment: 'Hidh dorë nga Pagesa',
    completePayment: 'Përfundo Pagesën',
    importantUpdate: 'Përditësim i Rëndësishëm',
    accountUpdate: 'Përditësim i Llogarisë',
    youHave: 'Keni',
    exceededTheMessagesLimit: 'kaluar limitin e mesazheve',
    ofYour: 'të tuajat',
    planAnd: 'plan dhe',
    botsAreNoLongerActive: 'botët nuk janë më aktivë',
    onYourWebsite: 'në faqen tuaj të internetit.',
    youHaveEitherIncompletePaymentOn: 'Keni ose pagesë të paimë të',
    orYouHaveNotSuccessfullyUpgradedYourPlan: 'ose nuk keni ndërtuar me sukses planin tuaj.',
    orYouHaveNotSuccessfullyWhiteLabeledYourBot: 'ose nuk keni ndërtuar me sukses botën tuaj.',
    orYouHaveNotSuccessfullyPurchasedTheMessagesAddOn: 'ose nuk keni blerë me sukses "Messages Add-on".',
    incompletePaymentMessage: 'Keni ose pagesë të paimë në ose nuk keni ndërtuar me sukses planin tuaj.',
    please: 'Ju lutemi',
    complete: 'Përfundo',
    upgrade: 'Ndërto',
    services: 'shërbimet',
    yourPlanToContinueServices: 'planin tuaj për të vazhduar shërbimet',
    yourPaymentToContinue: 'pagesën tuaj për të vazhduar',
    forAnyQueryPleaseWriteUs: 'Për çdo pyetje, ju lutemi na shkruani në',
    close: 'Mbyll',
    writeOn: '',
    upgradePlan: 'Ndërto Planin',
    discardModal: {
        title: 'Hidh dorë nga Pagesa',
        description: 'A jeni të sigurt se doni të hidhni dorë nga pagesa juaj?',
        confirmText: 'Po, Hidh Dorë nga Pagesa'
    },
    maintenanceHeading: 'Njoftim i Afishuar për Mirëmbajtjen:',
    maintenanceNotice: 'Shërbimet e BotPenguin do të jenë përkohësisht të padisponueshme për shkak të mirëmbajtjes më 28/11/2023 nga ora 7:00 PM deri në 7:30 PM IST. Na vjen keq për mundimin. Do kemi kthim të shpejtë. Faleminderit për mirëkuptimin.'
},
bpExport: {
    exportStatus: 'Statusi i Eksportit',
    tasksExport: 'Eksporti i Detyrave',
    download: 'Shkarko',
    inProgress: 'në progres',
},
singleSession: {
    close: 'Mbyll',
    useHere: 'Përdor këtu',
    openInAnotherWindow: `${brand} është e hapur në një dritare/tab tjetër. Kliko "Përdor Këtu" për të përdorur ${brand} në këtë tab.`
}
};
